
export default {
    Best : "best-jokes",
    Newest : "most-recent"
}
